module.exports = __webpack_public_path__ + "img/82ne.179043e9.svg";